import type { AddProductsSourceKey } from '../../Tabs/ProductsTableBody/model/useAddProductsTransfer';
import type { ProposalShortageItem, ProposalShortageKind } from '../model/types';
import ShortageTableRow from './ShortageTableRow';

interface ProductSourceOption {
    key: AddProductsSourceKey;
}

interface ShortageTableBodyProps {
    kind: ProposalShortageKind;
    items: ProposalShortageItem[];
    proposalName: string;
    showActions: boolean;
    canAdd: boolean;
    sources: ProductSourceOption[];
    teamName: string;
    openTransfer: (key: AddProductsSourceKey, productId?: number) => void;
}

const ShortageTableBody = ({
    kind,
    items,
    proposalName,
    showActions,
    canAdd,
    sources,
    teamName,
    openTransfer,
}: ShortageTableBodyProps) => (
    <tbody>
        {items.map((item) => (
            <ShortageTableRow
                key={item.key}
                kind={kind}
                item={item}
                proposalName={proposalName}
                showActions={showActions}
                canAdd={canAdd}
                sources={sources}
                teamName={teamName}
                openTransfer={openTransfer}
            />
        ))}
    </tbody>
);

export default ShortageTableBody;
